import { Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FarmersService } from '../../farmers.service';
import { finalize, Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { Farmer, FarmerVisit } from '../../farmers.model';
import { PaginatedResponse } from '../../../common/models/common.model';
import { Product } from '../../../products/product.model';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { getDefaultProfilePicUrl, handleImageError } from '../../../utils';

@Component({
  selector: 'app-farmer-details',
  standalone: false,
  templateUrl: './farmer-details.component.html',
  styleUrl: './farmer-details.component.scss',
})
export class FarmerDetailsComponent implements OnInit, OnDestroy {
  @ViewChild('farmerVisit') farmerVisit!: TemplateRef<any>;

  isFarmerDetailsLoading: boolean = false;
  farmerId!: string;
  farmer!: Farmer;
  farmerVisits!: FarmerVisit[];
  selectedFarmerVisit: FarmerVisit = {} as FarmerVisit;

  totalCount: number = 0;
  hasNextPage: boolean = false;
  hasPreviousPage: boolean = false;
  modelRef!: NgbModalRef;

  private routeSub!: Subscription;
  protected currentPage: number = 1;

  constructor(
    private modalService: NgbModal,
    private farmerService: FarmersService,
    protected route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit() {
    this.isFarmerDetailsLoading = true;

    // ✅ Subscribe to route params
    this.routeSub = this.route.paramMap.subscribe(params => {
      this.farmerId = params.get('id')!; // 👈 gets /farmers/:id
      this.getFarmerDetails();
    });
  }

  getProductNames(products_recommended: Product[] | undefined | null): string {
    if (!products_recommended || products_recommended.length === 0) return '';
    return products_recommended.map(p => p.name).join(', ');
  }

  getFarmerDetails() {
    this.farmerService.get_farmer_by_id(this.farmerId).subscribe({
      next: (farmer: Farmer) => {
        this.farmer = farmer;
        this.getFarmerVisits();
      },
    });
  }

  getFarmerVisits(): void {
    const q = {
      page: this.currentPage,
      farmer_id: this.farmerId,
    };

    this.farmerService
      .get_farmer_visits(q)
      .pipe(
        finalize(() => {
          this.isFarmerDetailsLoading = false;
        })
      )
      .subscribe({
        next: (farmerVisitsResponse: PaginatedResponse<FarmerVisit>) => {
          this.farmerVisits = farmerVisitsResponse.results;
          this.totalCount = farmerVisitsResponse.count;
          this.hasNextPage = !!farmerVisitsResponse.next;
          this.hasPreviousPage = !!farmerVisitsResponse.previous;
        },
      });
  }

  protected onPageChange(page: number): void {
    this.currentPage = page;
    this.getFarmerVisits();
  }

  viewVisit(visit: FarmerVisit): void {
    this.selectedFarmerVisit = visit;

    this.modelRef = this.modalService.open(this.farmerVisit, { backdrop: 'static', size: 'xl' });
  }

  openImage(url: string) {
    window.open(url, '_blank'); // open full-size image in new tab
  }

  onBackToFarmers(): void {
    void this.router.navigate(['/farmers']);
  }

  ngOnDestroy() {
    this.routeSub?.unsubscribe();
    this.modelRef?.dismiss();
  }

  protected readonly getDefaultProfilePicUrl = getDefaultProfilePicUrl;
  protected readonly handleImageError = handleImageError;
}
